var map = {
	"./c++.svg": "e8c1",
	"./css.svg": "3542",
	"./expressjs.svg": "0ad3",
	"./firebase.svg": "9196",
	"./firefox.svg": "e0a4",
	"./flutter.svg": "08ea",
	"./html.svg": "a3e6",
	"./java.svg": "b7b9",
	"./javascript.svg": "a1d0",
	"./mongodb.svg": "225f",
	"./postgressql.svg": "b4e0",
	"./python.svg": "e736",
	"./pytorch.svg": "8037",
	"./react.svg": "f3c0",
	"./svelte.svg": "c6ea",
	"./vuejs.svg": "5d27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5936";